import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Logo from 'components/global/Logo';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import UserInfo from './UserInfo';

function TopBar({ user }) {
  const { locale } = user;

  return (
    <AppBar
      position="fixed"
      sx={theme => ({
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.25)',
      })}
    >
      <Toolbar
        style={{
          justifyContent: 'space-between',
          backgroundColor: '#FFFFFF',
          height: 80,
        }}
      >
        <div>
          <div>
            <Link to={user.is_admin ? '/admin' : '/dashboard'}>
              <Logo locale={locale} />
            </Link>
          </div>
        </div>
        <UserInfo user={user} />
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  user: PropTypes.object.isRequired,
};

export default TopBar;
